import { X } from 'lucide-react';
import { isMacOs } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { Button, IconButton } from '@/Domain/components/Shared/Button/Button';
import { Kbd } from '@/Domain/components/Shared/Kbd/Kbd';
import { SheetDescription, SheetHeader, SheetTitle } from '@/Domain/components/Shared/Sheet/sheet';

interface ArticleSheetHeaderProps {
  onSave: () => void;
  onClose: () => void;
  isLoading?: boolean;
}

export const ArticleSheetHeader = ({
  onSave,
  onClose,
  isLoading = false,
}: ArticleSheetHeaderProps) => {
  const { t } = useTranslation(['knowledge_base', 'common']);

  return (
    <SheetHeader className="!flex-row !items-center !justify-between">
      <SheetTitle className="truncate">
        {t('knowledge_base:article.edit_title', { defaultValue: 'Edit Article' })}
      </SheetTitle>
      <SheetDescription className="sr-only">{t('knowledge_base:article.title')}</SheetDescription>
      <div className="flex items-center gap-2 pr-1">
        <Button onClick={onSave} disabled={isLoading}>
          {t('common:Save')}
          {isMacOs ? (
            <>
              <Kbd keyLabel="cmd + s" variant="dark" />
            </>
          ) : (
            <>
              <Kbd keyLabel="ctrl + s" variant="dark" />
            </>
          )}
        </Button>
        <IconButton variant="secondary" onClick={onClose} data-testid="article-sheet-close">
          <X className="size-4" />
        </IconButton>
      </div>
    </SheetHeader>
  );
};
